var listenMiddleware = function (listener) { return function (store) { return function (next) { return function (action) {
    var previousState = store.getState();
    var result = next(action);
    listener(action, store.getState(), previousState);
    return result;
}; }; }; };
export default listenMiddleware;
